import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import ls from 'localstorage-slim';
import {
  CLIENT_NAME,
  X_CLIENT_ID,
  X_CLIENT_TYPE
} from '../../../app.constants';
import { Client } from '../../../core/auth/models/client.model';
import { AppState } from '../../../store';
import {
  loadDashboardApi,
  refreshDashboardApi,
  removeAccountsFromStore
} from '../../../store/actions/dashboard/dashboard.actions';

ls.config.encrypt = true;

@Component({
  selector: 'lns-profile-item',
  templateUrl: './profile-item.component.html',
  styleUrls: ['./profile-item.component.scss']
})
export class ProfileItemComponent {
  @Input() profile: Client | undefined;
  currentProfile: any = ls.get(X_CLIENT_ID);

  constructor(private router: Router, private store: Store<AppState>) {}

  selectProfile(profile: Client): void {  
    ls.set(X_CLIENT_ID, JSON.stringify(profile.clientId));
    ls.set(CLIENT_NAME, profile.clientName);
    ls.set(X_CLIENT_TYPE, profile.clientType);

    this.refreshDashboard();
  }

  refreshDashboard() {
    this.store.dispatch(removeAccountsFromStore());
    this.store.dispatch(loadDashboardApi());
    this.store.dispatch(refreshDashboardApi());
  }
}
